
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("5vocv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $40229ec7ce994920$var$_jquery = $40229ec7ce994920$var$_interopRequireDefault((parcelRequire("jG4hL")));
function $40229ec7ce994920$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $40229ec7ce994920$var$init = module.exports.init = function init() {
    // Main Navigation Sticky -----------------------------------------------------
    var intialtop = (0, $40229ec7ce994920$var$_jquery["default"])(document).scrollTop();
    var headerheight = (0, $40229ec7ce994920$var$_jquery["default"])("body .page-header").outerHeight();
    var fixed = true;
    (0, $40229ec7ce994920$var$_jquery["default"])(window).on("scroll", function() {
        var afterscrolltop = (0, $40229ec7ce994920$var$_jquery["default"])(document).scrollTop();
        var navVisible = (0, $40229ec7ce994920$var$_jquery["default"])(".nav-container-open").length;
        var pageHeader = (0, $40229ec7ce994920$var$_jquery["default"])("body:not(.flyout-header) .page-header");
        var flyPageHeader = (0, $40229ec7ce994920$var$_jquery["default"])("body.flyout-header .page-header");
        flyPageHeader.addClass("fixed");
        if (navVisible === 0) {
            // afterscrolltop > headerheight ? $(".page-header").addClass("navhide") : $(".page-header").removeClass("navhide");
            if (afterscrolltop > headerheight) {
                pageHeader.addClass("navhide");
                flyPageHeader.addClass("navhide");
            } else {
                pageHeader.removeClass("navhide");
                flyPageHeader.removeClass("navhide");
            }
            // afterscrolltop > intialtop ? $(".page-header").removeClass("fixed") :
            if (afterscrolltop > intialtop) pageHeader.removeClass("fixed");
            else {
                pageHeader.addClass("fixed");
                flyPageHeader.addClass("fixed");
            }
            // Beim nach oben Scrollen: fixed Header nur einblenden, wenn eine größere Distanz zurückgelegt wurde
            if (afterscrolltop > intialtop) pageHeader.removeClass("fixed");
            else if (intialtop - afterscrolltop > 10) {
                pageHeader.addClass("fixed");
                flyPageHeader.addClass("fixed");
            }
            // Version 2 bei Sprungmarkenmenü (siehe auch Zeile 390)
            if (fixed === false) pageHeader.removeClass("fixed");
            intialtop = (0, $40229ec7ce994920$var$_jquery["default"])(document).scrollTop();
            var half_height = (0, $40229ec7ce994920$var$_jquery["default"])(window).height() / 2;
            // $(this).scrollTop() > half_height ? $(".backtotop").fadeIn() : $(".backtotop").fadeOut();
            if ((0, $40229ec7ce994920$var$_jquery["default"])(this).scrollTop() > half_height) (0, $40229ec7ce994920$var$_jquery["default"])(".backtotop").fadeIn();
            else (0, $40229ec7ce994920$var$_jquery["default"])(".backtotop").fadeOut();
        }
    });
};

});


//# sourceMappingURL=stickyNav.module.286b88c5.js.map
